import { createAsyncAction, createAction } from '../reduxActions';

export const addChapterAction = createAction('ADD_CHAPTER');
export const deleteChapterAction = createAsyncAction('DELETE_CHAPTER');
export const saveChapterAction = createAsyncAction('SAVE_CHAPTER');
export const cancelChapterAction = createAction('CANCEL_CHAPTER');
export const retrieveChaptersAction = createAsyncAction('RETRIEVE_CHAPTERS');
export const showChaptersFormAction = createAction('SHOW_CHAPTERS_FORM');
export const removeChapterAction = createAction('REMOVE_CHAPTER');
export const setLastChaptersViewAction = createAction('SET_LAST_CHAPTERS_VIEW');
export const setDraftChaptersAction = createAction('SET_DRAFT_CHAPTERS');

export function retrieveChapters(recordingId) {
  return { type: retrieveChaptersAction.toString(), recordingId };
}

export function addChapter(recordingId, hoverTime) {
  return { type: addChapterAction.toString(), recordingId, hoverTime };
}

export function saveChapters(recordingId, chapters) {
  return { type: saveChapterAction.toString(), recordingId, chapters };
}

export function deleteChapter(recordingId, chapterId) {
  return { type: deleteChapterAction.toString(), recordingId, chapterId };
}

export function removeChapter(recordingId, index) {
  return { type: removeChapterAction.toString(), recordingId, index };
}

export function cancelChapter(recordingId) {
  return { type: cancelChapterAction.toString(), recordingId };
}

export function showChaptersForm(shouldShowChaptersForm) {
  return { type: showChaptersFormAction.toString(), shouldShowChaptersForm };
}

export function setLastChaptersView(view) {
  return { type: setLastChaptersViewAction.toString(), view };
}

export function setDraftChapters(recordingId, draftChapters, draftChapterErrors) {
  return { type: setDraftChaptersAction.toString(), recordingId, draftChapters, draftChapterErrors };
}
